module.exports = __webpack_public_path__ + "static/media/truck9.d1b03ab6.svg";